/* eslint-disable */
import Home from "./components/Home";

export const routes = [{ path: "/", component: Home, name: "Home" }];



// WEBPACK FOOTER //
// ./src/routes.js